module.exports = __webpack_public_path__ + "img/logo.2c723f6b.svg";